import m from "./../../../dist/es2015/locales/fo_FO.js";
export const am5locales_fo_FO = m;